// v-decimal — rewrites commas to dots as the user types, so decimal values
// parse correctly regardless of keyboard layout (Greek keyboards produce ','
// for the decimal separator). The rewrite happens on the native input event
// and is re-dispatched so v-model picks up the cleaned value; the no-comma
// guard makes the re-dispatched pass a no-op.

const onInput = (e) => {
    const input = e.target;
    if (!input.value || !input.value.includes(',')) return;

    input.value = input.value.replace(/,/g, '.');
    input.dispatchEvent(new Event('input', {bubbles: true}));
};

export default {
    bind(el) {
        // Works on a bare <input>/<textarea> or a component root that wraps one
        // (b-form-input renders a bare input, input-groups wrap it).
        const input = (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') ? el : el.querySelector('input, textarea');
        if (!input) return;

        input.addEventListener('input', onInput);
        el.__decimalInput__ = input;
    },
    unbind(el) {
        if (el.__decimalInput__) {
            el.__decimalInput__.removeEventListener('input', onInput);
            delete el.__decimalInput__;
        }
    }
};
